import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";

import useFetch from "./hooks/useFetch";
import CreateRoutes from "./routes";
import { getSiteSettingList } from "./services/siteSettingService";
import { getSettings } from "./redux/slice/settingsSlice";
import { verifyAuth } from "./redux/slice/authSlice";

import { HelmetProvider } from "react-helmet-async";
import { BannerProvider } from "./providers/BannerProviders";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { getCartList } from "./services/cartService";
import { setCartDetails } from "./redux/slice/cartSlice";
import { data } from "autoprefixer";
import { stepsList } from "./services/stepService";
import { restoreStepFromStorage, setSteps } from "./redux/slice/stepSlice";

// import { SocketProvider } from "./providers/SocketContext";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  const { session } = useSelector((state) => state?.authProvider);
  const userId = session?.user?._id;
  const role = session?.user?.role;
  // Fetch site settings
  useFetch({
    dependencies: ["siteSetting"],
    fetchFunction: async () => {
      const res = await getSiteSettingList();
      dispatch(getSettings(res?.data));
      return res?.data;
    },
  });
  useEffect(() => {
    dispatch(verifyAuth());
  }, [location.pathname, session?.status, dispatch]);
  useEffect(() => {
    const loadSteps = async () => {
      try {
        const res = await stepsList();
        if (res?.docs?.status === 200 && res?.docs?.data?.[0]?.steps) {
          dispatch(setSteps(res.docs.data[0].steps));
        }
      } catch (err) {
        console.error("Failed to fetch steps", err);
      }
    };

    loadSteps();
  }, [dispatch, userId]);
  useEffect(() => {
    const pathsToBlock = ["/cover-image", "/create"];

    if (!pathsToBlock.includes(location.pathname)) return;
    const handleBeforeUnload = (e) => {
      const message =
        "Are you sure you want to leave? Your progress may be lost.";
      e.preventDefault();
      e.returnValue = message; // Some browsers require this
      return message;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname]);

  // Fetch cart when user is authenticated
  const fetchCart = useCallback(async () => {
    try {
      const res = await getCartList();
      // console.log(res?.docs, "cart App");
      if (res?.docs?.status === 200) {
        dispatch(setCartDetails(res?.docs));
      } else {
        dispatch(setCartDetails({}));
      }
    } catch (err) {
      dispatch(setCartDetails({}));
      console.warn("Cart load failed");
    }
  }, [dispatch]);

  useEffect(() => {
    if (userId && role === "user") {
      fetchCart();
    }
  }, [userId, role, fetchCart]);

  return (
    <HelmetProvider>
      <BannerProvider>
        {/* <SocketProvider> */}
        <CreateRoutes />
        {/* </SocketProvider> */}
      </BannerProvider>
    </HelmetProvider>
  );
}

export default App;
